// This is a generated file!
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _define = require("../../define");
const iconSkTemplate = document.createElement('template');
iconSkTemplate.innerHTML = '<svg class="icon-sk-svg" xmlns="http://www.w3.org/2000/svg" width=24 height=24 viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>';
(0, _define.define)('delete-icon-sk', class extends HTMLElement {
    connectedCallback() {
        const icon = iconSkTemplate.content.cloneNode(true);
        while(this.firstChild){
            this.removeChild(this.firstChild);
        }
        this.appendChild(icon);
    }
});
